import { DiligenceItem } from "../docs/Diligence";
import { LegalCaseItem } from "../docs/LegalCase";
import { NewsItem } from "../docs/News";

export type MergedDocument =
  | (LegalCaseItem & { type: "legal_case" })
  | (NewsItem & { type: "news" })
  | (DiligenceItem & { type: "diligence" });

function usableTime(value: string | null | undefined): number | null {
  if (!value) return null;
  const time = new Date(value).getTime();
  return Number.isNaN(time) ? null : time;
}

function sortByDateDesc<T>(
  items: T[],
  getDate: (item: T) => string | null | undefined
): T[] {
  return items
    .map((item, index) => ({
      item,
      index,
      time: usableTime(getDate(item)),
    }))
    .sort((a, b) => {
      if (a.time !== null && b.time !== null) return b.time - a.time;
      if (a.time !== null) return -1;
      if (b.time !== null) return 1;
      return a.index - b.index;
    })
    .map(({ item }) => item);
}

function legalCaseDate(item: LegalCaseItem): string | null | undefined {
  return item.start_date || item.end_date;
}

export function mergeDocuments(
  legalCases: LegalCaseItem[],
  newsItems: NewsItem[],
  diligenceItems: DiligenceItem[]
): MergedDocument[] {
  const news = sortByDateDesc(
    newsItems.map((item) => ({ ...item, type: "news" as const })),
    (item) => item.date
  );
  const legal = sortByDateDesc(
    legalCases.map((item) => ({ ...item, type: "legal_case" as const })),
    legalCaseDate
  );
  const diligence = sortByDateDesc(
    diligenceItems.map((item) => ({ ...item, type: "diligence" as const })),
    (item) => item.date
  );

  return [...news, ...legal, ...diligence];
}
